import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Stack } from '../Stack/index.js';

const EPSidebar = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React__default.createElement(Stack, _extends({
    ref: ref,
    as: "aside",
    display: {
      md: 'flex'
    },
    mb: {
      base: 'space50',
      md: 'space0'
    },
    spacing: {
      base: 'space50',
      md: 'space60'
    }
  }, props));
});

export { EPSidebar };
